export enum ROUTE {
  KURV = '/kunde/privat/beregn-din-pris/kurv',
  MINE_DOKUMENTER = '/kunde/privat/min-side/indbakke',
  ANMELD_SKADE = '/kunde/privat/min-side/anmeld-skade',
  MINE_FORSIKRINGER = '/kunde/privat/min-side/mine-forsikringer',
  FORSIKRINGER = '/kunde/privat/min-side/forsikringer',
  BETALINGSSERVICE = '/kunde/privat/min-side/betalingsservice',
  MINE_SKADER = '/kunde/privat/min-side/mine-skader',
  MINE_KONTAKTOPLYSNINGER = '/kunde/privat/min-side/kontaktoplysninger',
  MINE_SAMTYKKER = '/kunde/privat/min-side/mine-samtykker',
  PORTABILITET = '/kunde/privat/din-side/portabilitet',
  INDSIGT = '/kunde/privat/din-side/indsigt',
  LOGOUT = '/pkmslogout?junction=privat'
}
